import { UIIcon } from '../config/icons';
import { CHXAxis, CHXYAxes, CHYAxis } from '../lib/ch/axes';
import { CHChart } from '../lib/ch/chart';
import { CHLegendBar } from '../lib/ch/legend';
import { CHLinePlot } from '../lib/ch/line';
import { CHSankey } from '../lib/ch/sankey';
import { CHLinearScale, CHTimeScale } from '../lib/ch/scale';
import { CHCol, CHRow, CHTable, CHTableData } from '../lib/ch/table';
import { cCityBySlug } from '../lib/mdl/c-city';
import { p_promos } from '../lib/mdl/p-promo-admin';
import { st_counts, st_metrics, st_parameters, STBundle, STCount, STFilter, STFlowsQuery, STFunnelStep, stGetParameters, STMetric, STOp, STParameter, stQuery, STQuery, stQueryFlows, stQueryFunnel, stQuerySQL, STScale, STSeries, STSQLRow } from '../lib/st/statistics';
import { $color, $colors } from '../lib/ui/color';
import { UIDataAdapter } from '../lib/ui/component/adapter';
import { UIButton } from '../lib/ui/component/button';
import { uiInitCodeEditor } from '../lib/ui/component/codeeditor';
import { UIDateInput } from '../lib/ui/component/date';
import { UIList } from '../lib/ui/component/list';
import { UISegmented } from '../lib/ui/component/segmented';
import { UISelect } from '../lib/ui/component/select';
import { UITable, UITableDefinition } from '../lib/ui/component/table';
import { uiToast } from '../lib/ui/component/toast';
import { UICheckbox, UIExclusiveToggles, UIToggle } from '../lib/ui/component/toggle';
import { addTooltip } from '../lib/ui/component/tooltip';
import { $el } from '../lib/ui/elements';
import { $fmt } from '../lib/ui/fmt';
import { UIScreen } from '../lib/ui/screen';
import { UIRelPos, UIValue } from '../lib/ui/types';
import { UIView, UIViewSpec } from '../lib/ui/view';
import { makeCSV } from '../lib/y/csv';
import { YArrayDataSource } from '../lib/y/data-source';
import { $log, xavis_experiments } from '../lib/y/debug';
import { $on, $trigger, YEventHandlers } from '../lib/y/events';
import { yTextToBlob } from '../lib/y/file-utils';
import { yEqual } from '../lib/y/object';
import { $date, $time, YDateScale } from '../lib/y/time';

// class FilterPopup extends UIView {
//     constructor() {
//         super('div', 'tl-filter-popup');

//         const firstPage = () => {
//             return $el.DIV('tl-filter-page', [
//                 $el.DIV('r-title', 'Filter by'),

//             ])
//         }
//     }
// }

const tip_formats = { day: 'EEE d MMM', week: 'EEE d MMM', quarter: 'QQ yyyy', month: 'MMM yyyy', year: 'yyyy', time: 'yyyy', rel_year: '', rel_month: '', rel_week: '', total: '' }
const op_values: UIValue<STOp>[] = [{ key: 'add', name: '+' }, { key: 'sub', name: '–' }, { key: 'mul', name: '×' }, { key: 'div', name: '÷' }];
const mixed_action_types = ['add_free', 'add_promo', 'addon', 'book', 'buy_more', 'change_amount', 'change_billing_date', 'change_payment', 'change_payment_fail',
    'change_plan', 'change_plan_fail', 'checkin', 'confirm', 'force_cancel', 'free_subscription', 'pause', 'payment_fail', 'payment_skipped',
    'payment_success', 'rating', 'redeem_gc', 'refund', 'reject', 'review', 'standby', 'standby_remove', 'standby_reserve', 'subscribe',
    'subscribe_fail', 'unbook', 'uncancel', 'uncheckin', 'unpause', 'unpause_fail', 'unsubscribe'];

class StepSelection extends UIView {
    $handlers: YEventHandlers<{ change: void, close: void }>;

    private _action: UISelect<string>; // TODO: should be user action code
    // private _last_query?: STQuery;
    // private _bundle?: Promise<STBundle>;

    constructor() {
        super('div', 'tl-step-selection');

        const action = this._action = new UISelect(mixed_action_types.map(k => ({ key: k, name: k })), { kind: 'k-flat', placeholder: 'Action' });

        this.ui_add([
            new UIButton({ icon: UIIcon.XMARK | UIIcon.WEIGHT_SOLID, kind: 'k-square', classes: 'r-close m-round', on_click: () => { $trigger(this, 'close') } }),
            action
        ]);

        const recalc = () => {
            if(action.value)
                $trigger(this, 'change');
        };

        $on(action, 'value', _m => {
            // count.values = $tl.statistics_metrics[m!].counts.map(k => ({ key: k, name: $tl.statistics_counts[k] }));
            // count.disabled = false;
            // if(!count.value)
            //     count.value = 'all';
            recalc();
        });
    }

    get action() {
        return this._action.value;
    }

    get step(): STFunnelStep {
        return {
            action: this._action.value!
        }
    }

    getBundle(_scale: STScale, _group: STParameter[]) {
        // const m = this._metric.value;
        // if(!m) return undefined;

        // const query: STQuery = {
        //     scale: scale,
        //     metric: this._metric.value!,
        //     counts: [this._count.value || 'all'],
        //     filter: {},
        //     group: group,
        //     pp: {
        //         accumulate: this._cumulative.value
        //     }
        // };

        // if(!this._last_query || !this._bundle || !yEqual(query, this._last_query)) {
        //     $log('app', 'doing query');
        //     this._last_query = query;
        //     this._bundle = $tl.queryStatistics(query);
        // } else {
        //     $log('app', 'reusing value');
        // }

        // return this._bundle;
    }
}

export class AdminNewFunnelsScreen extends UIScreen {
    protected override fillContent(content: UIViewSpec): void {
        stQueryFunnel({
            steps: [
                { action: 'subscribe' },
                { action: 'unsubscribe' },
                { action: 'subscribe' }
            ]
        });

        // const fillStuff = () => {
        //     fillChart();
        //     fillTable();
        // }

        const steps_adapter = new UIDataAdapter((_q: STQuery | undefined) => {
            const step = new StepSelection();
            // selection.value = q;
            // selection.on_series = fillStuff;
            return step;
        })

        const steps = new UIList(steps_adapter, { classes: 'r-steps' });

        const chart = new CHChart;
        // const table = new UITable<STSeries>();

        content.ui_add($el.SECTION('w-block', [
            steps,
            new UIButton({ kind: 'k-text', title: 'ADD NEW STEP', on_click: () => { steps_adapter.push(undefined) } }),
            new UIButton({
                title: 'Run', on_click: () => {
                    stQueryFunnel({
                        steps: steps_adapter.views.map(v => v.step)
                    });
                }
            }),
            chart,
            // table
        ]));

        // const fillChart = () => {

        // }

        // const fillTable = () => {

        // }

        steps_adapter.data = [undefined];
    }
}

export class AdminNewSQLScreen extends UIScreen {
    protected override fillContent(content: UIViewSpec): void {
        const editor_element = $el.DIV('tl-sql-editor b');

        const table = new UITable<STSQLRow>();

        let editor: AceAjax.Editor | undefined;

        uiInitCodeEditor().then(() => {
            editor = ace.edit(editor_element);
            editor.setShowFoldWidgets(false);
            editor.setShowPrintMargin(false);
            editor.renderer.setShowGutter(false);
            editor.session.setMode('ace/mode/sql');
            editor.focus();
        })

        content.ui_add($el.SECTION('w-block', [
            editor_element,
            $el.DIV('r-inputs', new UIButton({
                title: 'Run', on_click: () => {
                    if(!editor) return;
                    return stQuerySQL(editor.getValue()).then(result => {
                        $log('app', '%O', result);
                        const def = new UITableDefinition<STSQLRow>();
                        const cols = result.cols;
                        for(let i = 0; i < cols.length; i++) {
                            const c = cols[i];
                            if(c.type == 'UInt64' || c.type == 'UInt32')
                                def.addValue(v => v[i] as number, $fmt.NUMBER, { title: c.name });
                            else
                                def.addValue(v => v[i] + '', { title: c.name });
                        }

                        table.reset(def, new YArrayDataSource(result.rows));
                        table.ui_show();
                    }, err => {
                        $log('app', 'catching', err)
                        uiToast((err.data.data && err.data.data.body) ? err.data.data.body : err.data.message);
                        table.ui_hide();
                    });
                }
            })),
            table
        ]));
    }
}

export class AdminNewFlowsScreen extends UIScreen {
    constructor() {
        super();
        this.title = 'Flows';
        this.classList.add('m-fixed');
    }

    protected override fillContent(content: UIViewSpec): void {
        content.classList.add('l-v');

        const chart = new CHChart({ autoresize: true, classes: 'tl-flow-chart' });

        // TODO: maybe use some of the commented out CSS for tl-flow-chart

        const mode_values = [{ key: 'from', name: 'Starting with' }, { key: 'to', name: 'Ending with' }, { key: 'around', name: 'Around' }];
        const mode = new UISelect(mode_values);
        mode.value = 'from';
        const action = new UISelect(mixed_action_types.map(t => ({ key: t, name: t })));

        const recalc = () => {
            const mode_value = mode.value;
            const action_value = action.value;

            if(!mode_value || !action_value) return;

            const query: STFlowsQuery = { depth: 9 };
            if(mode_value == 'around')
                query.around = action_value;
            else if(mode_value == 'to')
                query.to = action_value;
            else
                query.from = action_value;

            stQueryFlows(query).then(result => {
                const sankey_data = result.steps.map(s => ({ total: s.total, others: s.others, items: s.items.map(i => ({ key: i.event, count: i.count, next: i.next })) }))
                chart.setElements([new CHSankey(sankey_data)]);
            });
        }

        const sidebar = this.addSidebar(UIRelPos.Left, 210, 'l-v');
        sidebar.ui_add([mode, action]);

        content.ui_add($el.SECTION('', [
            $el.DIV('l-h-scroll w-block b', chart)
        ]));

        $on(mode, 'value', recalc);
        $on(action, 'value', recalc);
    }
}

const scale_values: UIValue<STScale>[] = [{ key: 'day', name: 'Day' }, { key: 'week', name: 'Week' }, { key: 'month', name: 'Month' }, { key: 'quarter', name: 'Quarter' }, { key: 'year', name: 'Year' }, { key: 'time', name: 'Time' }];

const metric_values: UIValue<STMetric>[] = (Object.keys(st_metrics) as STMetric[]).filter(k => {
    const spec = st_metrics[k];
    if(k.startsWith('experiment_') && !xavis_experiments) return false;
    return !spec.when || spec.when();
}).map(k => ({ key: k, name: st_metrics[k].name }));

const count_values: UIValue<STCount>[] = (Object.keys(st_counts) as STCount[]).map(k => ({ key: k, name: st_counts[k] }));

class OperatorSelection extends UIExclusiveToggles<UIValue<STOp>, STOp> {
    parent?: MetricGroup;

    constructor(parent: MetricGroup) {
        super(op_values, v => new UIToggle($el.SPAN(v.key == 'add' ? 'r-default r-segment' : 'r-segment', v.name), { key: v.key }), { classes: 'tl-statistics-op f-empty' });
        this.parent = parent;
        this.value = 'add';
        $on(this, 'value', () => {
            this.parent?.onOp(this);
        })
    }
}

// class FilterSelection extends UIView {
//     constructor() {
//         super('div', 'tl-filter-selection');

//         const parameter_values: UIValue<STParameter>[] = (Object.keys(st_parameters) as STParameter[]).map(k =>
//             ({ key: k, name: st_parameters[k].name }));

//         const parameter = new UISelect(parameter_values, { kind: 'k-flat' });

//         this.ui_add(parameter);
//     }
// }

class MetricFilters extends UIView {
    private _group_by: STParameter[];

    constructor(_parent: MetricGroup | MetricItem) {
        super('div', 'tl-statistics-filters');

        this._group_by = [];

        const add_filter = new UIButton({
            kind: 'k-text', title: 'FILTER', on_click: () => {
                // const m = metric.value;
                // if(!m) return;
                // const ms = $tl.statistics_metrics[m];
                // const parameters = ms.parameters.map(p => ([p,$tl.statistics_parameters[p]] as [STParameter, STParameterSpec]));
                // const popup = new UIDropdown<UIValue<STParameter>>(parameters.map(p => ({key: p[0], name: p[1].name})), valueDropdownGenerator)
                // // popup.on_choose = v => on_language(v.key);
                // popup.open(add_filter, { position: UIRelPos.Below | UIRelPos.End, adjust_size: true, match_size: true, capture_mouse: true });
            }
        });
        const add_breakdown = new UIButton({
            kind: 'k-text', title: 'BREAKDOWN', on_click: () => {
            }
        });
        // const filters_adapter = new UIDataAdapter((_q: STQuery | undefined) => {
        //     // const selection = new PlotSelection(scale_input.value!);
        //     // // selection.value = q;
        //     // selection.on_series = fillStuff;
        //     // return selection;
        //     return new FilterSelection
        // })

        this.ui_add([add_filter, add_breakdown]);

        // const filters = new UIList(filters_adapter, { classes: 'r-filters' });

        // const parameter_values: UIValue<STParameter>[] = (Object.keys($tl.statistics_parameters) as STParameter[]).map(k => 
        //                                                                                 ({ key: k, name: $tl.statistics_parameters[k].name }));

        // const parameter = new UISelect(parameter_values, { kind: 'k-flat' });

        // this.ui_add(parameter);

        // const group_by = new UIMultiToggles(params, p => new UICheckbox({ key: p, title: $tl.statistics_parameters[p].name }), { classes: 'r-group' });

        // $on(group_by, 'value', v => {
        //     this._group_by = v;
        //     // this._calcBundle();
        // });
    }

    combineFilters(filters: STFilter[]) {
        return [...filters];
    }

    combineGroupBy(group_by: STParameter[]) {
        return [...new Set([...group_by, ...this._group_by])].sort();
    }
}

type MetricChild = MetricItem | MetricGroup;

interface MetricParent {
    onChange(child: MetricChild): void;
    onClose(child: MetricChild): void;
    onReplace(from: MetricChild, to: MetricChild): void;
}

class MetricItem extends UIView {
    parent: MetricParent;

    private _metric: UISelect<STMetric>;
    private _count: UISelect<STCount>;
    private _cumulative: UICheckbox;
    private _last_query?: STQuery;
    private _bundle?: Promise<STBundle>;

    constructor(parent: MetricParent) {
        super('div', 'tl-statistics-item m-metric');

        this.parent = parent;

        const metric = this._metric = new UISelect(metric_values, { kind: 'k-flat', placeholder: 'Metric' });
        const count = this._count = new UISelect(count_values, { kind: 'k-flat', placeholder: 'Count', disabled: true });
        const cumulative = this._cumulative = new UICheckbox({ title: 'Cumulative' });
        const filters = new MetricFilters(this);

        const add_button = new UIButton({
            icon: UIIcon.PLUS, classes: 'r-add', on_click: () => {
                const group = new MetricGroup(this.parent);
                this.parent.onReplace(this, group);
                group.addItem(this);
                group.addItem();
            }
        });

        this.ui_add([
            add_button,
            new UIButton({ icon: UIIcon.XMARK | UIIcon.WEIGHT_SOLID, kind: 'k-square', classes: 'r-close m-round', on_click: () => { this.parent?.onClose(this) } }),
            metric,
            count,
            cumulative,
            filters
        ]);

        let dont_recalc = false;

        const recalc = () => {
            if(dont_recalc) return;
            if(metric.value)
                this.parent?.onChange(this);
        };

        $on(metric, 'value', m => {
            dont_recalc = true;
            count.values = st_metrics[m!].counts.map(k => ({ key: k, name: st_counts[k] }));
            count.disabled = false;
            if(!count.value)
                count.value = 'all';
            dont_recalc = false;
            recalc();
        });

        $on(count, 'value', recalc);
        $on(cumulative, 'value', recalc);
    }

    get metric() {
        return this._metric.value;
    }

    calcBundle(scale: STScale, _filters: STFilter[] = [], group: STParameter[] = []) {
        const m = this._metric.value;
        if(!m) return Promise.reject('no metric');

        const query: STQuery = {
            scale: scale,
            metric: this._metric.value!,
            counts: [this._count.value || 'all'],
            filter: {},
            group: group,
            to: $time.now().add(6, $time.month),
            pp: {
                accumulate: this._cumulative.value
            }
        };

        if(!this._last_query || !this._bundle || !yEqual(query, this._last_query)) {
            this._last_query = query;
            this._bundle = stQuery(query);
        }

        return this._bundle;
    }
}

class MetricGroup extends UIView implements MetricParent {
    parent: MetricParent;

    private _container: HTMLElement;
    private _children: (MetricGroup | MetricItem)[];
    private _ops: OperatorSelection[];
    private _filters: MetricFilters;

    constructor(parent: MetricParent) {
        const container = $el.DIV('r-children');

        super('div', 'tl-statistics-item m-group');

        this.parent = parent;
        this._container = container;
        this._children = [];
        this._ops = [];

        // const params = (Object.keys(st_parameters) as STParameter[]).filter(p => {
        //     const spec = st_parameters[p];
        //     return !spec.when || spec.when();
        // });

        const add_button = new UIButton({
            icon: UIIcon.PLUS, classes: 'r-add', on_click: () => {
                const group = new MetricGroup(this.parent);
                this.parent.onReplace(this, group);
                group.addItem(this);
                group.addItem();
            }
        });

        this._filterGroupBy();

        // flags.ui_add(new UILabeled(group_by, { above: 'Group by' }));
        this.ui_add([
            add_button,
            container,
            this._filters = new MetricFilters(this)
        ]);
    }

    addItem(item?: MetricChild) {
        if(item)
            item.parent = this;
        else
            item = new MetricItem(this);

        if(this._children.length) {
            const op = new OperatorSelection(this);
            this._container.ui_add(op);
            this._ops.push(op);
        }
        this._container.ui_add(item);
        this._children.push(item);
    }

    private _filterGroupBy() {
        // const selected_metrics: STMetric[] = [];
        // for(const m of this._children) {
        // if(m.metric)
        //     selected_metrics.push(m.metric);
        // }
        // group_by.values = params.filter(p => selected_metrics.length && selected_metrics.every(m => $tl.statistics_metrics[m].parameters.includes(p)));
    }

    onOp(_op: OperatorSelection) {
        // filterGroupBy();
        // this._calcBundle();
    }

    onChange(_child: MetricChild) {
        this.parent.onChange(this);
        // filterGroupBy();
        // this._calcBundle() 
    }

    onReplace(from: MetricChild, to: MetricChild) {
        const index = this._children.indexOf(from);
        this._children[index] = to;
        from.ui_replace(to);
        to.parent = this;
        // this._calcBundle();
    }

    onClose(child: MetricItem | MetricGroup) {
        if(this._children.length < 2) return;
        let i = this._children.indexOf(child);
        child.remove();
        this._children.splice(i, 1);
        if(i > 0) i--;
        this._ops[i].remove();
        this._ops.splice(i, 1);

        if(this._children.length == 1)
            this.parent.onReplace(this, this._children[0]);
        // this._calcBundle();
    }

    calcBundle(scale: STScale, filters: STFilter[] = [], group_by: STParameter[] = []): Promise<STBundle> {
        const bundles = this._children.map(c => c.calcBundle(scale, this._filters.combineFilters(filters), this._filters.combineGroupBy(group_by)));
        return Promise.all(bundles).then(result => {
            let r = result[0];
            for(let i = 1; i < result.length; i++) {
                r = r.op(this._ops[i - 1].value!, result[i]);
            }
            return r;
        });
    }
}

class PlotSelection extends UIView implements MetricParent {
    private _scale: STScale;
    // private _calc_token?: {};

    private _child: MetricChild;

    bundle?: STBundle;
    tailed_bundle?: STBundle;
    on_series?: () => void;

    constructor(scale: STScale) {
        super('div', 'tl-statistics-container');

        this._scale = scale;
        this.ui_add(this._child = new MetricItem(this));
    }

    onChange(_child: MetricChild) {
        this._calcBundle();
    }

    onClose(_child: MetricChild) {

    }

    onReplace(from: MetricChild, to: MetricChild) {
        this._child = to;
        to.parent = this;
        from.ui_replace(to);
        // this._calcBundle();
    }

    private _calcBundle() {
        const scale = this._scale;
        $log('app', 'calculating bundle');

        this._child.calcBundle(scale).then(result => {
            this.bundle = result;
            this.tailed_bundle = result.tail(0);
            this.on_series && this.on_series();
        });

        // const bundles: { bundle: Promise<STBundle>; op: STOp; }[] = [];
        // const metrics = this._metrics;
        // const ops = this._ops;
        // const scale = this._scale;
        // const group_by = this._group_by;

        // for(const i=0;i<metrics.length;i++) {
        //     const b = metrics[i].getBundle(scale, group_by);
        //     if(b)
        //         bundles.push({ bundle: b, op: i > 0 ? ops[i-1].value! : 'add' });
        // }

        // if(!bundles.length) return;

        // const token = this._calc_token = {};

        // Promise.all(bundles.map(b => b.bundle)).then(result => {
        //     if(token != this._calc_token) return;

        //     const final = result[0];

        //     for(const i=1;i<result.length;i++) {
        //         final = final.op(bundles[i].op, result[i]);
        //     }

        //     this.bundle = final;
        //     this.tailed_bundle = final.tail(0);
        //     this.on_series && this.on_series();
        // });
    }

    set scale(s: STScale) {
        this._scale = s;
        this._calcBundle();
    }

    markInvalid() {
        return false;
    }

    focus() {

    }
}

function calcLabel(prefix: string, group: STFilter) {
    const l: string[] = [];

    for(const g in group) {
        const param = st_parameters[g as STParameter];
        const label = param.label && param.label(group[g as STParameter]);
        if(label) l.push(label);
    }

    return prefix + (prefix && l.length ? ' - ' : '') + l.join('/');
}

export class AdminNewAnalyticsScreen extends UIScreen {
    protected override fillContent(content: UIViewSpec): void {
        stGetParameters().then(response => {
            $log('app', 'statistics parameters', response);
        })

        const fillStuff = () => {
            fillChart();
            fillTable();
        }

        const from_input = new UIDateInput;
        if(xavis_experiments)
            from_input.value = $date.make(2021, 11, 1);
        else
            from_input.value = $date.make(2017, 11, 1);
        const to_input = new UIDateInput;
        to_input.value = $date.today();

        const scale_input = new UISegmented(scale_values, { classes: 'm-compact m-light-border r-scale' });
        scale_input.value = 'month';

        const download_button = new UIButton({ icon: UIIcon.DOWNLOAD, kind: 'k-square', classes: 'm-action m-round', link: '' });
        addTooltip('Download', download_button, { offset: 8, hover: download_button, position: UIRelPos.Above });
        download_button.ui_hide();
        content.ui_add(download_button);

        const plots_adapter = new UIDataAdapter((_q: STQuery | undefined) => {
            const plot = new PlotSelection(scale_input.value!);
            // selection.value = q;
            plot.on_series = fillStuff;
            return plot;
        })

        const chart = new CHChart({ classes: 'b' });
        const table = new UITable<STSeries>();
        table.classList.add('b'); // TODO: add the option in table
        const legend = new CHLegendBar;
        legend.classList.add('b');

        const sidebar = this.addSidebar(UIRelPos.Left, 300, 'l-v');
        sidebar.ui_add($el.DIV('l-form', [
            new UIList(plots_adapter, { classes: 'r-selections b' }),
            $el.DIV('l-button-row b m-left', new UIButton({ kind: 'k-text', title: 'ADD NEW PLOT', on_click: () => { plots_adapter.push(undefined) } })),
        ]));

        content.ui_add($el.SECTION('w-block', [
            $el.DIV('tl-search-bar b', [$el.I('From'), from_input, $el.I('to'), to_input, $el.S(), scale_input]),
            $el.DIV('b', legend),
            chart,
            table
        ]));

        const fillChart = () => {
            const from = from_input.value;
            const to = to_input.value;
            const x_scale = new CHTimeScale;
            x_scale.tip_format = tip_formats[scale_input.value!];
            const axes = new CHXYAxes(new CHXAxis(x_scale), new CHYAxis(new CHLinearScale));

            let i = 0;
            const plots = plots_adapter.views;
            for(const p of plots) {
                const bundle = p.tailed_bundle;
                if(!bundle) continue;

                const prefix = '';
                // if(plots.length > 1)
                //     prefix = $tl.statistics_metrics[p.value!.metric].name;

                for(let j = 0; j < bundle.series.length; j++) {
                    const s = bundle.series[j];

                    axes.add(new CHLinePlot(bundle.linePoints(j, 0, from, to), {
                        color: s.key === 'other' ? $color.make(0xa0a0a0) : $color.make($colors.google[((i++) * 3 + 1) % $colors.google.length][5]),
                        label: s.key === 'other' ? 'Other' : calcLabel(prefix, s.group)
                    }));
                }
            }

            chart.setElements([axes]);
            legend.chart = chart
        };

        const fillTable = () => {
            download_button.ui_hide();
            const def = new UITableDefinition<STSeries>();

            const plots = plots_adapter.views;

            if(!plots.length) return;

            const bundle = plots[0].bundle;
            if(!bundle) return;

            const labels: { name: string, label: (v: any) => string, param: STParameter }[] = [];

            for(let b of bundle.group_by) {
                const param = st_parameters[b];
                const label = param.label;
                if(!label) continue;
                labels.push({ name: param.name, label, param: b });
                def.addValue(s => label(s.group[b]), { title: param.name, width: -160 });
            }

            let format: string;

            if(bundle.scale == 'month')
                format = 'yyyy-MM';
            else if(bundle.scale == 'year')
                format = 'yyyy';
            else
                format = 'yyyy-MM-dd';

            const dates = bundle.dates;
            const len = dates.length;
            let cols = 0;
            const now = $time.now();
            for(let i = 0; i < len && cols < 30; i++) {
                const date = $time(dates[len - i - 1]);
                if(date.after(now)) continue;
                def.addValue(s => s.values[0][len - i - 1], $fmt.NUMBERMAX(2), { title: date.format(format), width: -110 });
                cols++;
            }

            table.reset(def, new YArrayDataSource(bundle.series));

            const csv_array: (string | number)[][] = [];
            csv_array.push([...labels.map(l => l.name), ...dates.map(d => $time(d).format(format))]);
            for(let s of bundle.series) {
                csv_array.push([...labels.map(l => l.label(s.group[l.param])), ...s.values[0]]);
            }

            const csv = makeCSV(csv_array);
            const csv_url = URL.createObjectURL(yTextToBlob(csv, 'text/csv'));
            const csv_filename = 'statistics.csv';
            download_button.link = { href: csv_url, download: csv_filename };

            download_button.ui_show();
        };

        $on(scale_input, 'value', s => {
            for(const p of plots_adapter.views) {
                p.scale = s!;
            }
        });

        $on(from_input, 'value', fillStuff);
        $on(to_input, 'value', fillStuff);

        plots_adapter.data = [undefined];
    }
}

type RetentionCount = 'all' | 'users' | 'not_canceling' | 'mrr' | 'mrr_user' | 'booked' | 'bookings' | 'ticket_value' | 'payout_value' | 'login';

interface RetentionCountSpec {
    name: string;
    query_metric: STMetric;
    query_count: STCount;
    div?: boolean;
    relative?: RetentionCount;
}

const retention_counts: { [key in RetentionCount]: RetentionCountSpec } = {
    all: {
        name: 'Members',
        query_metric: 'members_current',
        query_count: 'all'
    },
    users: {
        name: 'Users',
        query_metric: 'members_current',
        query_count: 'users'
    },
    not_canceling: {
        name: 'Not canceling',
        query_metric: 'members_not_canceling',
        query_count: 'all'
    },
    mrr: {
        name: 'MRR',
        query_metric: 'members_current',
        query_count: 'mrr'
    },
    mrr_user: {
        name: 'MRR per user',
        query_metric: 'members_current',
        query_count: 'mrr',
        div: true,
        relative: 'all'
    },
    booked: {
        name: 'Users booked',
        query_metric: 'booking_booked',
        query_count: 'unique_users',
        relative: 'all'
    },
    bookings: {
        name: 'Bookings used',
        query_metric: 'booking_used',
        query_count: 'all',
        div: true,
        relative: 'all'
    },
    ticket_value: {
        name: 'Ticket value',
        query_metric: 'booking_used',
        query_count: 'value',
        div: true,
        relative: 'all'
    },
    payout_value: {
        name: 'Payout value',
        query_metric: 'booking_used',
        query_count: 'payout',
        div: true,
        relative: 'all'
    },
    login: {
        name: 'Login',
        query_metric: 'login',
        query_count: 'unique_users',
        relative: 'all'
    },
}

type RetentionCohorts = { [key: string]: number[] };

function calcRetentionData(count: RetentionCountSpec, cohorts: RetentionCohorts, ref_cohorts: RetentionCohorts | undefined, absolute: boolean, retention: STScale, rel_cohort: STParameter, month_1_ref: boolean): CHTableData {
    const today = $date.today();
    const all_base: number[] = [];
    const all: number[] = [];

    const cohort_scale: YDateScale = rel_cohort == 'year_cohort' ? $time.year : rel_cohort == 'week_cohort' ? $time.week : $time.month;
    const retention_scale: YDateScale = retention == 'rel_year' ? $time.year : retention == 'rel_week' ? $time.week : $time.month;

    const rows: CHRow[] = [];

    for(let date = $date.make(2016, rel_cohort == 'year_cohort' ? 1 : 10, rel_cohort == 'week_cohort' ? 7 : 1); date.before(today); date = date.add(1, cohort_scale)) {
        const cohort_key = date.format(rel_cohort == 'year_cohort' ? 'yyyy' : rel_cohort == 'week_cohort' ? 'yyyy-MM-dd' : 'yyyy-MM');
        const n_cols = Math.floor(today.sub(date.add(1, retention_scale), retention_scale) + 1);
        const cohort = cohorts[cohort_key];
        if(n_cols <= 0 || !cohort?.length) continue;

        let ref: number | number[];
        const labels: string[] = [date.format(rel_cohort == 'year_cohort' ? 'yyyy' : rel_cohort == 'week_cohort' ? 'yyyy-MM-dd' : 'MMM yyyy')];
        const values: number[] = [];

        if(ref_cohorts) {
            const ref_cohort = ref_cohorts[cohort_key];
            ref = month_1_ref ? ref_cohort[1] : ref_cohort[0];
            if(!ref) continue;
            labels.push(`${ref}`);

            ref = [];

            for(let j = 0; j < n_cols; j++) {
                const rv = j < ref_cohort.length ? ref_cohort[j] : 0;
                const v = j < cohort.length ? cohort[j] : 0;
                ref.push(rv);
                values.push(v);
                // const [td, formatted] = makeRetentionCell(v, rv || 1, absolute, count.div, month_1_ref);
                all[j] = (all[j] || 0) + v;
                all_base[j] = (all_base[j] || 0) + rv;
            }
        } else {
            ref = month_1_ref ? cohort[1] : cohort[0];
            if(!ref) continue;
            labels.push(`${ref}`);

            for(let j = 0; j < n_cols; j++) {
                const v = j < cohort.length ? cohort[j] : 0;
                values.push(v);
                // const [td, formatted] = makeRetentionCell(v, base, absolute, false, month_1_ref);
                all[j] = (all[j] || 0) + v;
                all_base[j] = (all_base[j] || 0) + ref;
            }
        }

        rows.push({ labels, values, ref });
    }

    const cols: CHCol[] = [];

    for(let i = 0; i < all.length; i++) {
        cols.push({ title: retention == 'rel_year' ? `Y${i}` : retention == 'rel_week' ? `W${i}` : `M${i}`, width: 75 });
    }

    rows.push({
        labels: ['All', `${all[0].toFixed(0)}`],
        values: all,
        ref: all_base,
        total: true
    });

    return {
        percentage: !count.div,
        absolute,
        rows,
        label_cols: [{ title: 'Cohort', width: 120, classes: 'm-left' }, { title: count.name, width: 80 }],
        cols
    }
}

export class AdminNewRetentionScreen extends UIScreen {
    constructor() {
        super();
        this.title = 'Retention';
        this.classList.add('m-fixed');
    }

    protected override fillContent(content: UIViewSpec): void {
        content.classList.add('l-v');

        const cohort_values: UIValue<STParameter>[] = [{ key: 'year_cohort', name: 'Yearly cohorts' }, { key: 'month_cohort', name: 'Monthly cohorts' }, { key: 'week_cohort', name: 'Weekly cohorts' }];
        const cohort = new UISelect(cohort_values);
        cohort.value = 'month_cohort';
        const retention_values: UIValue<STScale>[] = [{ key: 'rel_year', name: 'Yearly retention' }, { key: 'rel_month', name: 'Monthly retention' }, { key: 'rel_week', name: 'Weekly retention' }];
        const retention = new UISelect(retention_values);
        retention.value = 'rel_month';
        const one_ref = new UICheckbox({ title: 'Use 1 as reference' });

        const table = new CHTable;

        const count = new UISelect((Object.keys(retention_counts) as RetentionCount[]).map(c => ({ key: c, name: retention_counts[c].name })));
        count.value = 'all';
        const city = new UISelect([{ key: '', name: 'All cities' }, { key: cCityBySlug('stockholm')!.id, name: 'Stockholm' },
        { key: cCityBySlug('goteborg')!.id, name: 'Göteborg' }, { key: cCityBySlug('berlin')!.id, name: 'Berlin' }]);
        city.value = '';
        const country = new UISelect([{ key: '', name: 'All countries' }, { key: 'SE', name: 'Sweden' }, { key: 'DE', name: 'Germany' }]);
        country.value = '';
        const kind = new UISelect([{ key: '', name: 'All kinds' }, { key: 'plusone', name: 'Plus 1' }, { key: 'standard', name: 'Standard' }]);
        kind.value = '';
        const absolute = new UICheckbox({ title: 'Show absolute values' });

        const promo_values: UIValue[] = [{ key: '', name: 'All promos' }];
        for(const p of p_promos.all) {
            if(p.kind == 'signup')
                promo_values.push({ key: p.id, name: p.name });
        }
        const promo = new UISelect(promo_values);
        promo.value = '';

        const queries: { [k: string]: Promise<STBundle> } = {}

        const download_button = new UIButton({ icon: UIIcon.DOWNLOAD, kind: 'k-square', classes: 'm-action m-round', link: '' });
        addTooltip('Download', download_button, { offset: 8, hover: download_button, position: UIRelPos.Above });
        download_button.ui_hide();
        content.ui_add(download_button);

        function getQuery(count: RetentionCount) {
            const key = count + '|' + retention.value + '|' + cohort.value;

            if(!queries[key]) {
                const spec = retention_counts[count];
                queries[key] = stQuery({ scale: retention.value!, counts: [spec.query_count], metric: spec.query_metric, group: ['subscription_kind', 'user_country', 'user_city', cohort.value!, 'promo'] });
            }

            return queries[key];
        }

        function makeCohorts(bundle: STBundle) {
            bundle = bundle.collapse({ user_city: city.value || undefined, user_country: country.value || undefined, subscription_kind: kind.value || undefined, promo: promo.value || undefined });

            const cohort_value = cohort.value!;
            const cohorts: RetentionCohorts = {};
            for(const s of bundle.series) {
                cohorts[s.group[cohort_value]] = s.values[0];
            }

            return cohorts;
        }

        async function recalc() {
            download_button.ui_hide();
            const c = count.value!;
            const spec = retention_counts[c];
            if(spec.relative) {
                const [abs, ref] = await Promise.all([getQuery(c), getQuery(spec.relative)]);
                const cohorts = makeCohorts(abs);
                const ref_cohorts = makeCohorts(ref);
                table.data = calcRetentionData(spec, cohorts, ref_cohorts, absolute.value, retention.value!, cohort.value!, one_ref.value);
            } else {
                const abs = await getQuery(c)
                const cohorts = makeCohorts(abs);
                table.data = calcRetentionData(spec, cohorts, undefined, absolute.value, retention.value!, cohort.value!, one_ref.value);
            }

            download_button.link = table.download_link;
            download_button.ui_show();
        }

        $on(city, 'value', recalc);
        $on(country, 'value', recalc);
        $on(kind, 'value', recalc);
        $on(count, 'value', recalc);
        $on(promo, 'value', recalc);
        $on(absolute, 'value', recalc);
        $on(cohort, 'value', recalc);
        $on(retention, 'value', recalc);
        $on(one_ref, 'value', recalc);

        const sidebar = this.addSidebar(UIRelPos.Left, 240, 'l-v');
        sidebar.ui_add($el.DIV('l-form', [count, country, city, kind, promo]));

        content.ui_add([
            $el.SECTION('w-block', $el.DIV('tl-search-bar b', [cohort, retention, one_ref, absolute])),
            table
        ]);

        recalc();
    }
}
